import LZString from "lz-string";

// Storage keys
export const JWT_TOKEN = "jwtToken";
export const USER_PROFILE = "userProfile";
export const AUTH_FLAG = "auth";
export const USER_ROLE = "role";
export const HOME_PAGE = "homePage";

/**
 * Session-scoped storage helper.
 *
 * NOTE: This is NOT encryption. Values are stored in sessionStorage and only
 * LZString-compressed to reduce size — compression is trivially reversible in
 * any browser console. Do not treat anything written here as secret. It exists
 * to namespace access to sessionStorage and keep entries compact, nothing more.
 */
class SessionStore {
  set(key, data) {
    try {
      const stringifiedData = JSON.stringify(data);
      const compressedData = LZString.compress(stringifiedData);
      sessionStorage.setItem(key, compressedData);
      return true;
    } catch (error) {
      console.error("Error setting data in sessionStorage:", error);
      return false;
    }
  }

  get(key) {
    try {
      const compressedData = sessionStorage.getItem(key);
      if (!compressedData) return null;

      const decompressedData = LZString.decompress(compressedData);
      if (!decompressedData) return null;

      return JSON.parse(decompressedData);
    } catch (error) {
      console.error("Error getting data from sessionStorage:", error);
      return null;
    }
  }

  remove(key) {
    try {
      sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error("Error removing data from sessionStorage:", error);
      return false;
    }
  }

  clear() {
    try {
      sessionStorage.clear();
      return true;
    } catch (error) {
      console.error("Error clearing sessionStorage:", error);
      return false;
    }
  }

  // Helper methods for common operations
  getToken() {
    return this.get(JWT_TOKEN);
  }

  setToken(token) {
    return this.set(JWT_TOKEN, token);
  }

  getUserProfile() {
    return this.get(USER_PROFILE);
  }

  setUserProfile(profile) {
    return this.set(USER_PROFILE, profile);
  }

  isAuthenticated() {
    return this.get(AUTH_FLAG) === true;
  }

  setAuthenticated(status) {
    return this.set(AUTH_FLAG, status);
  }

  getUserRole() {
    return this.get(USER_ROLE);
  }

  setUserRole(role) {
    return this.set(USER_ROLE, role);
  }

  getHomePage() {
    return this.get(HOME_PAGE) || "/";
  }

  setHomePage(page) {
    return this.set(HOME_PAGE, page);
  }
}

const SecureSS = new SessionStore();
export default SecureSS;
